<div class="dropdown is-active" #contextMenu>
    <div class="dropdown-menu">
        <div class="dropdown-content">
            <ng-container *ngFor="let option of options">
                <ng-template [cdkPortalOutlet]="option"></ng-template>
            </ng-container>
        </div>
    </div>
</div>
